import { combineReducers } from 'redux';
import listings from './listings';
import viewSurvey from './viewSurvey';

export * from './listings';

export default combineReducers({
  listings,
  viewSurvey,
});
